module.exports = __webpack_public_path__ + "img/electron-prepa@2x.a94ce4c4.png";